import { render, staticRenderFns } from "./sendWhatsApp.vue?vue&type=template&id=24e47d92"
import script from "./sendWhatsApp.vue?vue&type=script&lang=js"
export * from "./sendWhatsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports